import React, { PureComponent } from 'react'
import { connect } from 'redaction'
import PropTypes from 'prop-types'
import actions from 'redux/actions'

import Overlay from 'components/layout/Overlay/Overlay'

import BeautyBagSteps from '../BeautyBagSteps/BeautyBagSteps'
import Header from './Header/Header'
import Content from './Content/Content'
import Footer from './Footer/Footer'

import s from './Sidebar.scss'


class CartSidebar extends PureComponent {

  static propTypes = {
    isVisible: PropTypes.bool,
    totalCount: PropTypes.number,
  }

  handleMount = (el) => {
    if (el) {
      setTimeout(() => {
        el.classList.add(s.mounted)
      }, 0)
    }
  }

  render() {
    const { isVisible, isBeautyBagExist, totalCount } = this.props

    if (!isVisible) {
      return null
    }

    return (
      <Overlay className={s.overlay} onClick={actions.models.cart.close}>
        <div
          className={s.cartSidebar}
          ref={this.handleMount}
          onClick={(event) => event.stopPropagation()}
        >
          <Header />
          {
            isBeautyBagExist && (
              <BeautyBagSteps className={s.beautyBugSteps} />
            )
          }
          <Content />
          {
            Boolean(totalCount) && (
              <Footer />
            )
          }
        </div>
      </Overlay>
    )
  }
}


export default connect({
  isVisible: 'models.cart.isVisible',
  isBeautyBagExist: 'models.cart.isBeautyBagExist',
  totalCount: 'models.cart.totalCount',
})(CartSidebar)
